/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1BannerIdQueryResponse,
  GetApiV1BannerIdPathParams,
  GetApiV1BannerId401,
  GetApiV1BannerId404,
  GetApiV1BannerId500,
} from "../../types/bannerRegistroController/GetApiV1BannerId.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1BannerId } from "../../clients/bannerRegistroController/getApiV1BannerId.ts";

export const getApiV1BannerIdQueryKey = (
  id: GetApiV1BannerIdPathParams["id"],
) => [{ url: "/api/v1/banner/:id", params: { id: id } }] as const;

export type GetApiV1BannerIdQueryKey = ReturnType<
  typeof getApiV1BannerIdQueryKey
>;

export function getApiV1BannerIdQueryOptions(
  id: GetApiV1BannerIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1BannerIdQueryKey(id);
  return queryOptions<
    GetApiV1BannerIdQueryResponse,
    ResponseErrorConfig<
      GetApiV1BannerId401 | GetApiV1BannerId404 | GetApiV1BannerId500
    >,
    GetApiV1BannerIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1BannerId(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados completos de um banner pelo seu identificador. **(Requer Authorization para autenticação)**
 * @summary Obter banner por ID (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:id}
 */
export function useGetApiV1BannerId<
  TData = GetApiV1BannerIdQueryResponse,
  TQueryData = GetApiV1BannerIdQueryResponse,
  TQueryKey extends QueryKey = GetApiV1BannerIdQueryKey,
>(
  id: GetApiV1BannerIdPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1BannerIdQueryResponse,
        ResponseErrorConfig<
          GetApiV1BannerId401 | GetApiV1BannerId404 | GetApiV1BannerId500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1BannerIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1BannerIdQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1BannerId401 | GetApiV1BannerId404 | GetApiV1BannerId500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
